import { createAsyncThunk } from '@reduxjs/toolkit';
import { ActionStatus } from '../../../common/constants/action-status';
import { StoreState } from '../../../store/store.interface';
import { getAccessCodeApiCall, redeemAccessCodeApiCall } from '../api/access-code.api';

/*----- DECLARE THUNKS ------*/
export const getAccessCodeDetails = createAsyncThunk(
  'accessCode/getDetails',
  async (code: string, thunkAPI) => {
    try {
      if (code) {
        return await getAccessCodeApiCall(code);
      }

      return thunkAPI.rejectWithValue({
        message: 'Missing access code.',
        code
      });
    } catch (error) {
      return thunkAPI.rejectWithValue({
        error,
        code
      });
    }
  },
  {
    condition: ((_args: string, { getState }) => {
      const state = getState() as StoreState;
      return state.accessCodeState.status !== ActionStatus.loading;
    })
  }
);

export const redeemAccessCode = createAsyncThunk(
  'accessCode/redeem',
  async (code: string, thunkAPI) => {
    try {
      if (code) {
        return await redeemAccessCodeApiCall(code);
      }
      return thunkAPI.rejectWithValue({ code: 'INVALID' });
    } catch (error) {
      const response = error as { code?: string; message?: string };
      const responseBody = response as { response?: { code?: string; errorCode?: string } };
      return thunkAPI.rejectWithValue({
        code: response.code || responseBody.response?.code || responseBody.response?.errorCode || 'REDEEM_FAILED',
        message: response.message || 'Unable to redeem access code.'
      });
    }
  }
);

